import React, { useEffect } from "react";
import * as echarts from "echarts";

const MonthWisePWINIGraph = ({
  selectedMonths,
  selectedSections,
  sortedPrev,
  sortedCurr,
  selectedRT,
  selectedFy,
  int,
}) => {
  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};

  const calcTotal = (data, section, key) =>
    selectedMonths.reduce((sum, month) => {
      const m = data.find((o) => o.month.slice(0, 3) === month);
      return sum + Number(getSectionData(m, section)[key] || 0);
    }, 0);

  useEffect(() => {
    if (!selectedMonths.length || !selectedSections.length) return;

    const chart = echarts.init(document.getElementById("pwiChart6"));

    const rt = selectedRT.toLowerCase();

    const sectionData = selectedSections
      .map((section) => {
        const prevINT = calcTotal(sortedPrev, section, `${rt}_to_intensive`);
        const currINT = calcTotal(sortedCurr, section, `${rt}_to_intensive`);
        const prevNINT = calcTotal(
          sortedPrev,
          section,
          `${rt}_to_nonintensive`
        );
        const currNINT = calcTotal(
          sortedCurr,
          section,
          `${rt}_to_nonintensive`
        );

        return {
          section,
          prevINT,
          currINT,
          prevNINT,
          currNINT,
          total: prevINT + currINT + prevNINT + currNINT,
        };
      })
      .sort((a, b) => b.total - a.total);

    const label = {
      show: true,
      position: "top",
      rotate: 55,
      fontSize: 12,
      verticalAlign: "middle",
    };

    const prevFy = selectedFy.replace(/\d+/g, (y) => +y - 1);

    const option = {
      title: {
        text: `INT & N-INT Comparison – Prev (${prevFy}) vs Curr (${selectedFy})`,
        left: "center",
      },
      tooltip: { trigger: "axis" },
      legend: {
        top: 30,
        data: [
          `INT (${prevFy})`,
          `INT (${selectedFy})`,
          `N-INT (${prevFy})`,
          `N-INT (${selectedFy})`,
        ],
      },
      xAxis: {
        type: "category",
        data: sectionData.map((d) => d.section),
      },
      yAxis: { type: "value" },
      series: [
        {
          name: int === "Int" ? `INT (${prevFy})` : `N-INT (${prevFy})`,
          type: "bar",
          data:
            int === "Int"
              ? sectionData.map((d) => d.prevINT)
              : sectionData.map((d) => d.prevNINT),
          label,
        },
        {
          name: int === "Int" ? `INT (${selectedFy})` : `N-INT (${selectedFy})`,
          type: "bar",
          data:
            int === "Int"
              ? sectionData.map((d) => d.currINT)
              : sectionData.map((d) => d.currNINT),
          label,
        },
        // {
        //   name: `N-INT (${prevFy})`,
        //   type: "bar",
        //   data: sectionData.map((d) => d.prevNINT),
        //   label,
        // },
        // {
        //   name: `N-INT (${selectedFy})`,
        //   type: "bar",
        //   data: sectionData.map((d) => d.currNINT),
        //   label,
        // },
      ],
    };

    chart.setOption(option);

    const handleResize = () => {
      chart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [
    selectedMonths,
    selectedSections,
    sortedPrev,
    sortedCurr,
    selectedRT,
    selectedFy,
  ]);

  return (
    <div className="papaDiv">
      <div
        id="pwiChart6"
        style={{ width: "100%", height: "50vh", marginTop: "30px" }}
      />
    </div>
  );
};

export default MonthWisePWINIGraph;
